export const styles = theme => ({
  toolbarColor: { backgroundColor: '#444A59' },
  typographyStyle: {
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '15',
  },
});
